module.exports = {
  GAS: 'CFX',
  USDT: 'USDC',
  TOKEN: 'TXT',
  TOKEN_NAME: 'Traderbot X Token',
  DEX: 'SWAPPI',
  PRIMARY_COLOR: '#347A6C',
  CHAIN_NAME: 'CONFLUX ESPACE',
  CHAIN_ID: 1030,
  MAINNET_FORK: true,
  PROVIDER_URL: 'https://evm.confluxrpc.com', // 'https://evm.confluxrpc.com', // http://localhost:8545 
  ROUTER_ADDRESS: '0x62b0873055bf896dd869e172119871ac24aea305',
  FACTORY_ADDRESS: '0xe2a6f7c0ce4d5d300f97aa7e125455f5cd3342f5',
  TOKEN_LINK: 'https://evm.confluxscan.io/token/0xb7C611454994Da5056f9450a3470E6aB7B245B04',
  NFT_LINK: 'https://evm.confluxscan.io/token/0xA70AEb0a2f9D81D3b75E50736791821DB6cF6846',
  VAULT_LINK: 'https://evm.confluxscan.io/address/0x4c0dde4d078efcde8ac99cea7d2e3de846d05f77?tab=contract-viewer',
  VAULTREWARD_LINK: 'https://evm.confluxscan.io/address/0xb3857cf682f8ba9fa6bf72f12463b30002b970c1?tab=contract-viewer',
  LPVAULT_LINK: 'https://evm.confluxscan.net/address/0x06487daeef4ab6459ad2c94006667cd93fd68d07?tab=contract-viewer',
  TRADE_LINK: 'https://app.swappi.io/#/swap?inputCurrency=CFX&outputCurrency=0xb7C611454994Da5056f9450a3470E6aB7B245B04',
  FORUM_LINK: 'https://forum.conflux.fun/t/traderbot-x-v2-token-nft-vault/16035',
  TELEGRAM_LINK: 'https://t.me/+r4bHssDPCbwyNzc1',
  TWITTER_LINK: 'https://twitter.com/traderbotx',
  SERVER: 'https://3d7c-54-169-184-214.ap.ngrok.io',
  TOKEN_IMAGE: 'https://res.cloudinary.com/dey55ubjm/image/upload/v1651118670/tbotx/logo192.png',
  CHART_LINK: 'https://dexscreener.com/conflux/0x2c5224b24277134cb5cec82541d23c2f769205de',
  DEXTOOLS: 'DEXSCREENER',
  EXPLORER_TX: 'https://evm.confluxscan.net/tx/',
  LP_LINK: 'https://app.swappi.io/#/add/v2/CFX/0xb7C611454994Da5056f9450a3470E6aB7B245B04', // 'https://swappi.io/#/add/v2/CFX/0xb7C611454994Da5056f9450a3470E6aB7B245B04'
  ZVR_LINK: "https://evm.confluxscan.io/address/0xD84627399abeDe867Ee11fb854cb0939F9e1C90d?tab=contract-viewer",
  ZV_LINK: "https://evm.confluxscan.io/address/0x481CbE3AC67dAC0513E6a4E793FdB6d0067626F7?tab=contract-viewer"
};


